import { FC, useRef, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import type { XYCoord, Identifier } from "dnd-core";
import { Dropdown } from "reactstrap";
import { DropdownToggle } from "reactstrap";
import CombinedShape from "../../../images/CombinedShape.svg";
import { DropdownMenu,DropdownItem } from "reactstrap";
// import CustomerService from "../../Services/CustomerService";
import { Modal } from "reactstrap";
import ShortcutForm from "./ShortcutForm";
import { toast } from "react-toastify";
// import SpinnerModel from "../../commonFields/SpinnerModel";
import { AxiosError } from "axios";
import Service from "../../../services";
import { catchError } from "../../../utils/Utils";
// import { catchError } from "../../Utils/Utils";

export interface CardProps {
  userQuickLinksId: string;
  name: string;
  index: number;
  moveCard: (dragIndex: number, hoverIndex: number) => void;
  url: string;
  type: number;
  setRefreshShortcuts: (setRefreshShortcuts:boolean)=>void;
}

interface DragItem {
  index: number;
  id: string;
  type: string;
}

export const FooterCard: FC<CardProps> = ({
  userQuickLinksId,
  name,
  index,
  moveCard,
  url,
  type,
  setRefreshShortcuts,
}) => {


  const ref = useRef<HTMLDivElement>(null);
  const [{ handlerId }, drop] = useDrop<
    DragItem,
    void,
    { handlerId: Identifier | null }
  >({
    accept: "card",
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item: DragItem, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();

      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      // Determine mouse position
      const clientOffset = monitor.getClientOffset();

      // Get pixels to the top
      const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top;

      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%

      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex);

      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "card",
    item: () => {
      return { userQuickLinksId, index };
    },
    collect: (monitor: any) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [myTodoToggle, setTodoToggle] = useState<number>();
  const [loader, setLoader] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const setIsOpen = (index: number) => {
    if (index == myTodoToggle) {
      setTodoToggle(-1);
    } else {
      setTodoToggle(index);
    }
  };
  const service = new Service();
  const onDeleteCard = (shortcutId: string) => {
    const data={
      "sections": "UserQuickLink",  
      "data": {  
          "userQuickLinksId":shortcutId  
      }  
  }
    service
      .deleteQuickLink(data)
      .then((response: any) => {        
        setRefreshShortcuts(true);
        toast.success(`Shortcut deleted Successfully`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        setLoader(false);
      });
  };

  const [displayShortcutModal, setDisplayShortcutModal] = useState<boolean>();
  const onEditCard = () => {
    setDisplayShortcutModal(true);
  };

  const toggle = () => {
    setDisplayShortcutModal(!displayShortcutModal);
  };
  const closeToggle = () => {
    setDisplayShortcutModal(false);
  };
  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const redirectLink = (url: string) => {
    window.open(url);
  };
  return (
    <>
      {/* {loader ? (
        <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />
      ) : null} */}
      {/* <ToastContainer /> */}
      <div
        className="shortCutPanel"
        ref={ref}
        style={{ opacity }}
        data-handler-id={handlerId}
      >
        <div
          className="cardTitle"
          onClick={() => {
            redirectLink(url);
          }}
        >
          {name}
        </div>
        <Dropdown
          className="img"
          toggle={() => setIsOpen(index)}
          isOpen={index == myTodoToggle}
        >
          <DropdownToggle>
            <img src={CombinedShape} alt="nothing" />
          </DropdownToggle>
          <DropdownMenu container="body" className="footerOptions">
            <DropdownItem
              onClick={() => {
                onEditCard();
              }}
            >
              Edit
            </DropdownItem>
            <DropdownItem onClick={() => onDeleteCard(userQuickLinksId)}>
              Delete
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Modal
          className="shortcutModal"
          isOpen={displayShortcutModal}
          fade={false}
          toggle={toggle}
        >
          <ShortcutForm
            name={name}
            url={url}
            type={type}
            userQuickLinksId={userQuickLinksId}
            toggle={() => toggle}
            closeToggle={closeToggle}
            setRefreshShortcuts={setRefreshShortcuts}
          />
        </Modal>
      </div>
    </>
  );
};
